<template>
    <a class="tooltip-more"
       v-on:click="showModal"
       :data-operation-id="operation.id"
       :data-toggle="'tooltip'"
       :data-placement="'top'"
       :data-original-title="tooltip">
        <i v-if="!force_plus" :class="{
              'fa fa-plus': method != null && method === 'create',
              'fa fa-eye': method != null && method === 'show',
              'fa fa-pen': method != null && method === 'edit'
            }"></i>
        <i v-else :class="{
              'fa fa-plus': true,
            }"></i>
        <operation-connect-with-modal ref="modal"
                                      :operation="operation"
                                      :method="method"
                                      :action-type="method"
                                      :operationIndex="index"
                                      :groupName="groupName"
                                      :disabled="disabled"
                                      :isDepartmentTransfer="true"
                                      :helpName="help"
                                      v-on:hideModal="modalHideHandler">
        </operation-connect-with-modal>
    </a>
</template>

<script>
import OperationConnectWithModal from "./OperationConnectWithModal";
import actions from "../../vuex/action_types";
import store from "../../vuex/store";
import mutations from "../../vuex/payments/mutation_types";
import events from "../../services/Events";
import axios from "axios";

export default {
    name: "ConnectWithModalButton",
    components: {OperationConnectWithModal},
    data: function () {
        return {
            groupName: 'operations',
            help : this.localizedHelpName()

        }
    },
    props: {
        operation: {
            type: Object,
            required: true,
            validator: function (operation) {
                let valid = true;
                ['contractor_id'].forEach(value => valid = operation.hasOwnProperty(value));
                return valid;
            }
        },
        index: {
            type: Number,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        force_plus: {
            type: Boolean,
            required: false,
            default: false,
        },
        method: {
            type: String,
            required: false
        },
        open_modal_method: {
            type: String,
            required: false
        },
        openModalOperationId: {
            type: Number,
            required: false,
        },

        tooltip:{
            type: String,
            required: false
        },
        source_department:{
            type: Number,
            required: false,
        },
        target_department:{
            type: Number,
            required: false,
        },
        departments:{
            type: Array,
            required: false,
        },
        group:{
            type: Object,
            required: true,
        },
        amount_to_transfer:{
            type:Number,
            default: 0,
        },
        type_of_transfer:{
            type: String,
            required: true,
        }
    },
    methods: {
        showModal: function () {
            const self = this;
            axios.post("/check-is-locked",{
                type: 'App\\Operation',
                operation_id: self.operation.id,
                lock:true,
                url: $('#current-url-to-lock').val(),
                route:$('#current-route-to-lock').val()
            }).then(function(response) {
                if(response.data.is_locked == true){
                    window.location.href = '/lock/' + response.data.lock_id + '?redirect=/records/department-all-transfers';
                }
                else{
                    if (self.type_of_transfer == 'transfer_not_accepted') {
                        axios.get('/records/payments/get-modal-content-in-target-department', {
                            params: {'operation_id': self.operation.id, 'target_department_id': self.target_department, 'contractor_id':self.operation.contractor.id}
                        })
                            .then(async (response) => {
                                await self.loadModalDataFromResponse(response)
                                self.refreshTargetDepartment()
                                self.calculateAllocationAndShowModal()
                                self.$refs.modal.transferTargetDepartment = self.target_department

                            })
                    } else {
                        axios.get('/records/payments/get-modal-content-in-target-department-as-source-department', {
                            params: {'operation_id': self.operation.id, 'target_department_id': self.target_department, 'contractor_id':self.operation.contractor.id}
                        })
                            .then(async (response) => {
                                await self.loadModalDataFromResponse(response)
                                self.refreshTargetDepartment()
                                self.calculateAllocationAndShowModal()
                                self.$refs.modal.transferTargetDepartment = self.target_department
                            })
                    }
                }
            });

        },
        refreshTargetDepartment: function (){
            if(this.source_department !== undefined && this.target_department !== undefined){
                this.$refs.modal.operationDepartments = this.$refs.modal.prepareDepartments(this.source_department, this.target_department)
                this.$refs.modal.refreshDepartmentAllocationStruct()
                this.$refs.modal.transferToDepartmentAmount = this.amount_to_transfer
            }
        },
        loadModalDataFromResponse: function (response){
            return this.$store.dispatch(actions.FETCH_SELECT2_CONTRACTORS_LIST).then(()=>{
                this.$refs.modal.dynamicContent = response.data.modalContext;
                store.commit(mutations.SET_DEPARTMENT, this.departments);
                store.commit(mutations.SET_GROUP_DATA, this.group);
                this.$refs.modal.loadModalData();
            });
        },
        calculateAllocationAndShowModal: function (){
            this.$refs.modal.calculateTotalAllocated();
            this.$refs.modal.calculateLeftForSplit();
            this.$refs.modal.modalVisible = true
            setTimeout(() => {
                $('.modal-dialog').draggable({
                    handle: ".modal-header"

                });
            }, 1000)

        },
        modalHideHandler: function () {
            this.$refs.modal.modalVisible = false
        },
        getOperationParentOrSelf: function(operation) {
            return this.$store.getters.getOperationParentOrSelf(operation)
        },
        getOperationRootOrSelf: function(operation) {
            return this.$store.getters.getOperationRootOrSelf(operation)
        },

        updateModalConfig: function (contractorId) {
            if (contractorId === 0) {
                this.$refs.modal.modalType = 'noContractor';
                this.$refs.modal.modalSize = 'lg';
                this.$refs.modal.colspan = 5;
            } else if (this.operation.contractor.global_account == 1) {
                this.$refs.modal.modalType = 'globalContractor';
                this.$refs.modal.modalSize = 'md';
                this.$refs.modal.colspan = 4;
            } else {
                this.$refs.modal.modalType = 'localContractor';
                this.$refs.modal.modalSize = 'xl';
                this.$refs.modal.colspan = 6;
            }
            this.localizedHelpName(this.$refs.modal.modalType);
            // this.$refs.modal.operationContractorTransfers = this.$refs.modal.prepareContractorTransfers();
        },
        localizedHelpName : function (contractorType) {
            switch (contractorType) {
                case 'localContractor':
                    this.help = "AEB-002";
                    break;
                case 'globalContractor':
                    this.help = "AEB-003"
                    break;
                default:
                    this.help = null;
                    break;
            }
        },
        isContractorGlobal: function (contractorId) {
            let contractorsFiltered = this.contractorsList.filter(contractor => contractor.id === parseFloat(contractorId))
            if(contractorsFiltered.length === 0) {
                return false;
            } else {
                return contractorsFiltered[0].is_global;
            }
        },
    },
    computed: {
        contractorsList: function () {
            return this.$store.getters.getSelect2ContractorsList;
        },
    },
    mounted: function () {
        const self = this;
        self.updateModalConfig(self.operation.contractor_id);
        if(this.openModalOperationId > 0){
            let modalVisible = this.openModalOperationId !== null && this.operation.id === parseFloat(this.openModalOperationId);
            if(modalVisible && (this.method == this.open_modal_method || (this.method + '?') == this.open_modal_method)){
                axios.post("/check-is-locked",{
                    type: 'App\\Operation',
                    operation_id: self.openModalOperationId,
                    url: $('#current-url-to-lock').val(),
                    route:$('#current-route-to-lock').val()
                }).then(function(response) {
                   if(response.data.is_locked == true){
                       window.location.href = 'lock/' + self.openModalOperationId;
                   }
                   else{
                       self.showModal();
                   }
                });

            }
        }
    },
    store
}
</script>

<style scoped>

</style>
